<script setup lang="ts">
  import { computed, defineAsyncComponent } from 'vue'
  import { useFeaturesStore } from '@/shared/store/featuresStore'

  const FlowResidenceWidget = defineAsyncComponent(
    () => import('@/widgets/Flow/FlowResidenceWidget/FlowResidenceWidget.vue')
  )
  const FlowResidenceWidgetQC = defineAsyncComponent(
    () => import('@/widgets/Flow/FlowResidenceWidgetQC/FlowResidenceWidgetQC.vue')
  )

  const featuresStore = useFeaturesStore()

  const isFirstStepQcEnabled = computed(() => featuresStore.isFirstStepQcEnabled)
</script>

<template>
  <FlowResidenceWidgetQC v-if="isFirstStepQcEnabled" />
  <FlowResidenceWidget v-else />
</template>
